import { Entry } from "./Entry";

import type { NoteBrowsingHistoryNode } from "~/client/components/search/hooks/useNoteBrowsingHistory";
import type { ListItemSelection } from "~/client/hooks/useSelectListItemByKey";
import type { Connection } from "~/client/utils/relay";

interface Props {
  listIndex: number;
  entries: Connection<NoteBrowsingHistoryNode>;
  listItemSelection: ListItemSelection;
}

const list = (entries: Connection<NoteBrowsingHistoryNode>, selected) => (
  <ul>
    {entries.edges.map((e) => (
      <Entry key={e.node.note.path} entry={e.node.note} isSelected={e.node.note.path === selected?.node.note.path} />
    ))}
  </ul>
);

export const EntryList: React.FC<Props> = ({ listIndex, entries, listItemSelection }) => {
  const selected = entries.edges.find((_, itemIndex) => listItemSelection.isItemSelected({ listIndex, itemIndex }));

  if (listItemSelection.isSubmitting && selected) {
    location.assign(selected.node.note.path);
  }

  return list(entries, selected);
};
